import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=5a51279b&scoped=true"
import script from "./Text.vue?vue&type=script&lang=ts"
export * from "./Text.vue?vue&type=script&lang=ts"
import style0 from "./Text.vue?vue&type=style&index=0&id=5a51279b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a51279b",
  null
  
)

export default component.exports